<template>
	<div class="link-card">
		<div class="column column_image">
			<p v-html="headline" class="headline"></p>
			<img :src="image" alt="" class="over_display" />
			<img :src="imageSp" alt="" class="under_display" />
		</div>
		<div class="column column_text">
			<div class="title">
				<p v-html="title"></p>
				<div class="link-btn"><PageLinkButton :link="pageLink" /></div>
			</div>
		</div>
	</div>
</template>

<script>
import PageLinkButton from '@/components/common/PageLinkButton.vue';
export default {
	name: 'link-card',
	components: {
		PageLinkButton,
	},
	props: {
		title: String,
		headline: String,
		image: String,
		imageSp: String,
		pageLink: String,
	},
};
</script>

<style lang="scss" scoped>
.link-card {
	height: 300px;
	position: relative;
	flex-direction: row-reverse;
	@media print, screen and (min-width: 1161px) {
		display: flex;
	}
	@media print, screen and (max-width: 1160px) {
		height: auto;
		margin-bottom: 60px;
	}
}
.link-card:nth-child(even) {
	flex-direction: row;
	.column_image {
		.headline {
			color: #fff;
			position: absolute;
			top: 50%;
			@media print, screen and (min-width: 1161px) {
				left: 50%;
				padding: 0;
				transform: translate(-50%, -50%);
			}
		}
	}
}
.link-card:last-of-type {
	@media print, screen and (min-width: 1161px) {
		margin-top: -1px;
	}
}
.column_image {
	position: relative;
	overflow: hidden;
	.headline {
		color: #fff;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		padding: 0 100px;
		font-family: 'Noto Serif JP';
		font-size: 17px;
		line-height: 2.5em;
		margin: 0;
		white-space: nowrap;
		@media print, screen and (max-width: 1160px) {
			padding: 10px;
			line-height: 2em;
		}
	}
	img {
		height: auto;
		vertical-align: middle;
	}
}
.column_text {
	position: relative;
	background-color: #dddddd;
	font-family: 'Noto Serif JP';
	font-size: 17px;
	max-width: 420px;
	width: 100%;
	@media print, screen and (max-width: 1160px) {
		padding: 30px 0;
		max-width: 100%;
	}
}
.title {
	position: relative;
	text-align: center;
	padding: 10px;
	@media print, screen and (min-width: 1161px) {
		top: 50%;
		transform: translateY(-50%);
	}
	p {
		margin: 0;
		font-size: 22px;
		line-height: 1.8em;
		letter-spacing: 0;
		@media print, screen and (max-width: 1160px) {
			font-size: 18px;
		}
	}
	.link {
		margin: 0 auto;
		margin-top: 50px;
	}
	.link-btn {
		margin-top: 30px;
		@media print, screen and (min-width: 1161px) {
			font-size: 40px;
		}
	}
}
</style>
